@let row = rowSg();

<div class="atn-mosaic-grid-row">
  @for (item of row.elements; track $index) {
    <div
      class="atn-mosaic-grid-row__element"
      [style.flex]="item.span"
    >
      <atn-mosaic-grid-element [element]="item.element" />
    </div>
  }
</div>
